<section role="region" class="cej-v2-contact">
  <h2 role="heading" class="cej-v2-contact__title">
    J&apos;ai des questions sur le Contrat d&apos;Engagement Jeune et souhaite être rappelé
  </h2>

  <button type="button" class="btn" (click)="openContactModal()" aria-label="Faire une demande pour être recontacté">
    Je souhaite être rappelé
  </button>
</section>
